var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutoexport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.805456 0.805456C1.32118 0.289731 2.02065 0 2.75 0H12.75C12.9489 0 13.1397 0.0790176 13.2803 0.21967L19.2803 6.21967C19.421 6.36032 19.5 6.55109 19.5 6.75V7.5L12.75 7.49998C12.3358 7.49998 12 7.16419 12 6.74998V1.5H2.75C2.41848 1.5 2.10054 1.6317 1.86612 1.86612C1.6317 2.10054 1.5 2.41848 1.5 2.75V21.25C1.5 21.5815 1.6317 21.8994 1.86612 22.1339C2.10054 22.3683 2.41848 22.5 2.75 22.5H16.75C17.0815 22.5 17.3995 22.3683 17.6339 22.1339C17.8683 21.8994 18 21.5815 18 21.25V18H19.5V21.25C19.5 21.9793 19.2103 22.6788 18.6945 23.1945C18.1788 23.7103 17.4793 24 16.75 24H2.75C2.02065 24 1.32118 23.7103 0.805456 23.1945C0.289731 22.6788 0 21.9793 0 21.25V2.75C0 2.02065 0.289731 1.32118 0.805456 0.805456ZM13.5 2.56066L16.9393 5.99998H13.5V2.56066Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9699 17.4697C16.6766 17.1768 16.6766 16.7019 16.9699 16.409L19.8827 13.5H9.75097C9.33622 13.5 9 13.1642 9 12.75C9 12.3358 9.33622 12 9.75097 12H19.9894L16.9699 8.9844C16.6766 8.69151 16.6766 8.21663 16.9699 7.92374C17.2632 7.63085 17.7387 7.63085 18.0319 7.92374L22.28 12.1664C22.5733 12.4593 22.5733 12.9341 22.28 13.227L18.0319 17.4697C17.7387 17.7626 17.2632 17.7626 16.9699 17.4697Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutoexport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/autoexport.b6f34cb49f74ca3deb2f9107448fa59f.svg";